import { Typography } from "@mui/material";

export const PropTypeLabel = ({ label, value }) => {
  return <Typography variant="h4">{label}</Typography>;
};
